import type { Resources } from '@/models/types';
import { OFFLINE_MAX_SECONDS, INITIAL_RESOURCES, RESOURCE_TYPES } from '@/models/constants';

export class IdleCalculator {
  static calculateProduction(
    rates: Resources,
    deltaSeconds: number,
    prestigeMultiplier: number,
  ): Resources {
    const result = { ...INITIAL_RESOURCES };
    for (const rt of RESOURCE_TYPES) {
      result[rt] = rates[rt] * deltaSeconds * prestigeMultiplier;
    }
    return result;
  }

  static calculateOfflineEarnings(
    rates: Resources,
    elapsedSeconds: number,
    prestigeMultiplier: number,
  ): Resources {
    const capped = Math.min(elapsedSeconds, OFFLINE_MAX_SECONDS);
    return IdleCalculator.calculateProduction(rates, capped, prestigeMultiplier);
  }

  static calculateBuildingCost(
    baseCost: Resources,
    costMultiplier: number,
    currentLevel: number,
  ): Resources {
    const result = { ...INITIAL_RESOURCES };
    const multiplier = Math.pow(costMultiplier, currentLevel);
    for (const rt of RESOURCE_TYPES) {
      result[rt] = Math.floor(baseCost[rt] * multiplier);
    }
    return result;
  }

  static calculateBuildingProduction(
    baseProduction: number,
    currentLevel: number,
    synergyBonus: number = 0,
  ): number {
    return baseProduction * currentLevel * (1 + synergyBonus);
  }
}
